import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import {
  StylesProvider,
  ThemeProvider,
  createStyles,
  jssPreset,
  makeStyles
} from '@material-ui/core';
import { create } from 'jss';
import { createBrowserHistory } from 'history';
import Auth from 'src/components/Auth';
import MomentUtils from '@date-io/moment';
import React from 'react';
import rtl from 'jss-rtl';
// import CookiesNotification from 'src/components/CookiesNotification';
// import SettingsNotification from 'src/components/SettingsNotification';
import { DEFAULT_LANGUAGE } from './constants';
import { createMuiTheme } from 'src/theme';
import GoogleAnalytics from 'src/components/GoogleAnalytics';
import Routes from 'src/Routes';
import ScrollReset from 'src/components/ScrollReset';
import useSettings from 'src/hooks/useSettings';

if (!sessionStorage.getItem('language')) {
  sessionStorage.setItem('language', DEFAULT_LANGUAGE);
}

const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '#root': {
        height: '100%',
        width: '100%'
      },
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      body: {
        height: '100%',
        width: '100%'
      },
      html: {
        '-moz-osx-font-smoothing': 'grayscale',
        '-webkit-font-smoothing': 'antialiased',
        height: '100%',
        width: '100%'
      }
    }
  })
);

function App() {
  useStyles();

  const { settings } = useSettings();

  return (
    <ThemeProvider theme={createMuiTheme(settings)}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider maxSnack={3} preventDuplicate={false}>
            <Router history={history}>
              <Auth>
                <ScrollReset />
                <GoogleAnalytics />
                {/* <CookiesNotification/> */}
                {/* <SettingsNotification/> */}
                <Routes />
              </Auth>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
}

export default App;
